module.exports = __webpack_public_path__ + "static/media/Vince Bohner.fb77e29e.png";